import { trelloStore, StoreScope, StoreType } from '../../services/trellostore';
import StoreKeys from '@/services/storekeys';
import Icons from '@/icons';
import channel from '@/cqs/channel';
import * as queries from  '@/cqs/queries'
import context from '@/services/ctx';
import {getDataForCardFront, getDataForCardBack, checkAccess} from '@/services/storiesonboardrepository';
import { CardData } from '@/cqs/remotequeries';
import { Dictionary } from 'typescript-collections';

class CardContextsModule implements ICardBadgesProvider,ICardDetailsBadgesProvider, ICardListSortersProvider {

    public getListSorters(t: ITrelloClient, opts: any): Promise<any[]> {
        return new Promise(async resolve => {
            var result = [];

            var getCards = async () => {
                const list = await t.list('all');                
                var hasAccess = await checkAccess(t);
                var cardDataMap = new Dictionary<string, CardData>();
                if(hasAccess) {
                    var cardDataTasks: Promise<CardData>[] = list.cards.select(card => getDataForCardFront(t, card.id));
                    var cardDatas = await Promise.all(cardDataTasks);
                    cardDatas.forEach(card => {
                        if(card != null) {
                            cardDataMap.setValue(card.Id, card);
                        }
                    });
                }
                
                var cards = [];
                list.cards.forEach(card => {
                    var cardData = cardDataMap.containsKey(card.id)
                        ? cardDataMap.getValue(card.id)
                        : null;
                    cards.push({ id: card.id, goal: cardData?.Goal, step: cardData?.Step});
                });

                return cards;
            }

            result = [
                {
                    text: "Goals & Steps",
                    callback: async (t, opts) => {
                        var cards = await getCards();
                        var sortedCards = cards.sort(function(a,b) {
                            const aStepLower = a.step?.toLowerCase();
                            const bStepLower = b.step?.toLowerCase();
                            const aGoalLower = a.goal?.toLowerCase();
                            const bGoalLower = b.goal?.toLowerCase();

                            function compareProperty(a, b) {
                                return (a != b) ? (a == null ? 1 : b == null ? -1 : (a < b ? -1 : 1)) : 0;
                            }

                            return compareProperty(aGoalLower, bGoalLower) || compareProperty(aStepLower, bStepLower);
                        });
                        return {
                            sortedIds: sortedCards.map(function (c) { return c.id; })
                        };
                    }
                }
            ];
            
            resolve(result);
        });
    }


    public getCardBadges(t: ITrelloClient, opts:any) : Promise<Array<any>> {
        return this.createBadges(true, t, opts,
            goal => {
                return { 
                    text: goal.truncate(28),
                    icon: Icons.Goal.BadgeIcon
                }
            },
            step => {
                return {
                    text: step.truncate(28),
                    icon: Icons.Step.BadgeIcon
                }
            });
    }


    public getCardDetailsBadges(t: ITrelloClient, opts: any): Promise<any[]> {
        return this.createBadges(false, t, opts,
            (goal: string, goalDetails?: string, goalUrl?: string) => {
                return {
                    title: 'Goal',
                    text: goal.truncate(28),
                    callback: (t) => {
                        return t.popup({
                            title: 'Goal details',
                            url: './views/relatedinfopopup.html',
                            args: {
                                title: goal,
                                description: goalDetails,
                                url: goalUrl
                             },
                            height: 150
                        });
                    }
                }
            },
            (step: string, stepDetails?: string, stepUrl?: string) => {
                return {
                    title: 'Step',
                    text: step.truncate(28),
                    callback: (t) => {
                        return t.popup({
                            title: 'Step details',
                            url: './views/relatedinfopopup.html',
                            args: { 
                                title: step,
                                description: stepDetails,
                                url: stepUrl
                            },
                            height: 150
                        });
                    }
                }
            });
    }
    
    public async createBadges(
        isFront: boolean, 
        t: ITrelloClient, 
        opts:any, 
        goalBadgeFactory: (goal: string, goalDetails?: string, goalUrl?: string) => any, 
        stepBadgeFactory: (step: string, stepDetails?: string, stepUrl?: string) => any
    ) : Promise<Array<any>> {

        var badges = [];
        var hasAccess = await checkAccess(t);
        if(hasAccess) {
            var ctx = await context(t).get();
            var cfg = ctx.config;
            if (cfg.isShowCardContext){

                if (isFront) {
                    var card = await getDataForCardFront(t, opts.context.card);
                    if(card != null) {
                        if(cfg.isShowCardContextGoalOnCardFront && card.Goal != null) {
                            badges.push(goalBadgeFactory(card.Goal));
                        }
                        if(cfg.isShowCardContextStepOnCardFront && card.Step != null) {
                            badges.push(stepBadgeFactory(card.Step));
                        }
                    }
                }
                else {
                    var cardBack = await getDataForCardBack(t, opts.context.card);

                    if(cardBack != null && cfg.isShowCardContextOnCardBack) {
                        if(cardBack.Goal != null) {
                            badges.push(goalBadgeFactory(cardBack.Goal, cardBack.GoalDetails, cardBack.GoalUrl));
                        }
                        if(cardBack.Step != null) {
                            badges.push(stepBadgeFactory(cardBack.Step, cardBack.StepDetails, cardBack.StepUrl));
                        }
                    }
                }
               
            }
        } 

        return badges;
    }
}
export var cardContextModule = new CardContextsModule();
export default cardContextModule;
